import React, { useContext, useEffect, useState } from "react";
import ViewImage from "../../../assets/overView.png";
import PrimaryHeading from "../../../utils/PrimaryHeading/PrimaryHeading";
import offer from "../../../assets/Offer.svg";
import YouTube from "react-youtube";

import DialogDemo from "../dialog/Dialog";
import Timer from "../../../main/Timer/Timer";
import { MyContext } from "../../../pages/Funnel";
import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";

const CourseOverView = ({ program_overview }) => {
  const { state } = useContext(MyContext);
  return (
    <div className="flex justify-between max-w-7xl m-auto max-sm:flex-col max-sm:gap-10 max-sm:px-5">
      <section className="max-w-[641px]">
        <PrimaryHeading>Course Overview</PrimaryHeading>
        <p className="font-normal text-lg mt-4 text-[#4A4A4A] text-justify max-sm:text-base">
          {program_overview}
        </p>
      </section>
      <section className="bg-white px-5 py-8 flex max-w-xl justify-between shadow-md rounded-sm w-full">
        <div className=" text-[#FFFF01] text-xs font-medium self-start flex items-center max-w-28 w-full justify-center relative max-sm:hidden ">
          <img src={offer} alt="img" />
          <span className="block text-[0.7rem] w-20 italic absolute  text-center">
            Join Now
          </span>
        </div>
        <div className="max-sm:w-full">

          <h2 className="text-textColor mb-4 font-semibold text-center">
            Limited Seats Available!
          </h2>
          <div className=" max-w-[230px] max-sm:max-w-full">
            <img className="w-full" src={ViewImage} alt="ViewImage" />
            <Timer />
            <PrimaryBtn className='w-full'>Join Now</PrimaryBtn>
          </div>
        </div>
        <div className=" text-[#FFFF01] text-xs font-medium self-end  flex items-center max-w-28 w-full justify-center relative max-sm:hidden ">
          <img src={offer} alt="img" />
          <span className="block text-[0.7rem] w-20 italic absolute  text-center">
            Join Now
          </span>
        </div>
      </section>
    </div>
  );
};

export default CourseOverView;
